export default "__VITE_ASSET__CWeycSgS__"